class OakReadMoreAnimator {
  constructor() {
    // Initialize the component by finding the elements in the DOM
    this.readMoreContainer = document.querySelector(".oak-readmore-container");
    this.readMoreToggle = this.readMoreContainer.querySelector(".oak-readmore");
    if (!this.readMoreToggle) {
      console.warn("OakReadMoreAnimator: No read more container found.");
      return; // Exit the constructor if the container doesn't exist
    }

    this.readMoreDescription = this.readMoreContainer.querySelector(
      ".oak-readmore-description"
    );

    this.plusIcon = this.readMoreToggle.querySelector(".readmore-icon.open");
    this.minusIcon = this.readMoreToggle.querySelector(
      ".readmore-icon:not(.open)"
    );

    // Bind the click event listener
    this.readMoreToggle.addEventListener("click", () =>
      this.toggleDescription()
    );
  }

  toggleDescription() {
    // Toggle the 'open' class on the description and icons to show/hide content and swap icons
    this.readMoreDescription.classList.toggle("open");
    this.plusIcon.classList.toggle("open");
    this.minusIcon.classList.toggle("open");
  }
}

// Instantiate the class when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => new OakReadMoreAnimator());
